import React, { useEffect } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { createTheme, ThemeProvider, Button, SvgIcon } from '@material-ui/core';

import Age from '../Helpers/Dates/Age';
import { HeaderStepper } from '../Quoters/Common/HeaderStepper/HeaderStepper';
import { getSessionStorageItem, SESSION_STORAGE_POLICY_REVIEW, getBasicInfo } from '../../sessionStorage';
import States from '../Helpers/Lists/States';
import CallToAction from './CallToAction/CallToAction';
import DeathBenefitIcon from '../../icons/deathBenefit.svg'
import CalendarScheduleIcon from '../../icons/calendarSchedule.svg';

import './Summary.scss';

export default function Summary(props) {

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const formStateFromSession = getSessionStorageItem(SESSION_STORAGE_POLICY_REVIEW);
  let basicInfo = getBasicInfo();

  const toBeReviewedText = () => {
    if (!formStateFromSession) {
      return '0';
    }
    const count = formStateFromSession.termPolicies.length + formStateFromSession.permPolicies.length;

    return `${count} ${count > 1 ? 'policies' : 'policy'} to be reviewed`;
  }

  const fullState = () => {
    if (!basicInfo) {
      return "";
    }
    return States().find(s => s.value === basicInfo.state).label;
  }

  const age = () => {
    if (!basicInfo) {
      return null;
    }

    return `${Age(basicInfo.birthdate)} years old`;
  }

  return (
    <HeaderStepper
      title="Your request for a policy review has been submitted"
      hideProgressTracker={true}
      hideContact={true}
    >
      <Container className="summary-container">
        <Row className="lgaModalInputs">

          <Col lg={6} className='pr-5'>
            <div className='mx-5 mt-0 appointment-class py-3 px-5'>
              <h3 className="text-center title">Appointment Summary</h3>
              <h5 className="text-center subtitle mb-3">Policy Review</h5>
              <p className='bold-text'>Number of Policies</p>
              <p className='answer-text'>{toBeReviewedText()}</p>
              <Row>
                <Col xs={6}>
                  <p className='bold-text'>Gender</p>
                  <p className='answer-text'>{(basicInfo && basicInfo.gender) && basicInfo.gender === 'M' ? 'Male' : 'Female'}</p>
                </Col>
                <Col xs={6}>
                  <p className='bold-text'>Age</p>
                  <p className='answer-text'>{age()}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <p className='bold-text'>State</p>
                  <p className='answer-text'>{fullState()}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <p className='bold-text'>Email</p>
                  <p className='answer-text'>{formStateFromSession && formStateFromSession.schedule.email}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <p className='bold-text'>Phone Number</p>
                  <p className='answer-text'>{formStateFromSession && formStateFromSession.schedule.phone}</p>
                </Col>
              </Row>

            </div>
          </Col>
          <Col lg={6} className='margin-class'>
            <div className='mx-4 ml-5 mt-4'>
              <h4 className="mb-3">Your Appointment has been scheduled</h4>
              <p className='para-text'>
                {formStateFromSession && (formStateFromSession.schedule.specificAppt.toLowerCase() === "schedule") ? "One of our licensed specialists will contact you as requested." : "One of our licensed specialists will contact you within one business day."}
              </p>
            </div>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col>
            <CallToAction
              title="Get a personalized insurance quote today"
              subtitle="A great rate is just a few clicks away."
              actions={
                <div className="button-container d-flex">
                  <Button className="button-block" color="primary" href="/landing/term">
                    <div className="icon"><SvgIcon component={CalendarScheduleIcon} color='primary' /></div>TERM LIFE<br />INSURANCE</Button>
                  <Button className="button-block" color="primary" href="/landing/permanent">
                    <div className="icon"><SvgIcon component={DeathBenefitIcon} color='primary' /></div>PERMANENT<br />LIFE INSURANCE</Button>
                </div>
              } />
          </Col>
        </Row>
      </Container>
    </HeaderStepper>
  )
}



// WEBPACK FOOTER //
// ./src/components/PolicyReview/Summary.js